import React, { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import LegalLinks from './legal/LegalLinks';
import { useAuth } from '../contexts/AuthContext';
import { UserRole } from '../types';

interface DashboardLayoutProps {
  requiredRole: UserRole;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ requiredRole }) => {
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== requiredRole) return <Navigate to={`/${user.role}`} replace />;

  return (
    <div className="min-h-screen bg-[#f6f6f6]">
      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-30 lg:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      {/* Sidebar */}
      <div className={`fixed top-0 left-0 z-40 h-full transition-transform duration-300 lg:translate-x-0 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        <Sidebar onClose={() => setSidebarOpen(false)} />
      </div>

      {/* Main content — proper spacing from edges.
          Yapışkan altbilgi: sayfa içeriği ekranı doldurmadığında altbilgi
          içeriğin hemen altında boşlukta asılı kalmasın, ekranın altına
          insin. `grow` (flex-basis'e dokunmayan flex-grow) bilerek `flex-1`
          yerine kullanıldı — içerik ekrandan uzunsa `flex-basis: 0` bazı
          tarayıcılarda taşmayı yanlış hesaplıyor. */}
      <div className="lg:ml-[240px] xl:ml-[280px] min-h-screen flex flex-col">
        <div className="px-6 xl:px-10 pt-4 xl:pt-5 grow flex flex-col">
          {/* Mobile hamburger */}
          <button onClick={() => setSidebarOpen(true)} className="lg:hidden mb-3 p-1.5 rounded-[10px] bg-[#fafafa] hover:bg-gray-100">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="#2b2b2b">
              <path d="M3 6h18v2H3zM3 11h18v2H3zM3 16h18v2H3z"/>
            </svg>
          </button>
          <TopBar />
          <div className="grow">
            <Outlet />
          </div>

          {/* Aydınlatma metni ve çerez tercihleri, uygulamanın her sayfasından
              bir tık uzakta olmalı — profil sayfasına gömülü tek bir bağlantı
              "kolay erişilebilir" sayılmaz. */}
          <footer className="mt-10 border-t border-[#e9e9e9] pt-5 pb-4">
            <LegalLinks />
          </footer>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
